import React, { PropTypes } from 'react';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { push as routerPush } from 'react-router-redux';
import { selectChannel } from '../../workspace/store/actions';
import moment from 'moment';
import pluralize from 'pluralize';

const SelectableList = makeSelectable(List);

const styles = {
  main: {
    width: '334px',
    height: '100%',
    overflowVertical: 'auto',
  },
  semitransparent: {
    opacity: '0.8',
  },
  list: {
    padding: '0px !important',
  },
  listItem: {
    fontSize: '14px !important',
    borderBottom: '1px solid rgb(224, 224, 224) !important',
    '&>div>div': {
      padding: '10px 10px 10px !important',
    },
  },
  secondaryText: {
    fontSize: '11px !important',
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 179, 207)',
    height: '48px',
  },
};

class massMessagingList extends React.Component {
  state = {
    searchTxt: '',
  };
  handleChange = (event, index) => {
    if (!this.props.conversationsFetching) { // do not allow a new selection if something is being loaded
      this.props.routerPush(`/workspace/bulkmessages/${index}`);
    } else {
      return false;
    }
  }
  render() {
    const { classes, channels, selectedChannel, conversationsFetching } = this.props;
    const channelsFormated = channels.map(channel => {
      const retVal = {};
      if (moment().startOf('day').diff(moment(channel.sentAt || channel.createdAt), 'days') < 1) {
        retVal.sentAtFormatted = moment(channel.sentAt || channel.createdAt).format('[Today at] h:ma');
      } else {
        retVal.sentAtFormatted = moment(channel.sentAt || channel.createdAt).format('MMM DD YYYY [at] ha');
      }
      return Object.assign(channel, retVal);
    }
      );
    return (
      <div className={classes.main}>
        <div className={classes.channelsTitle}>Bulk Message Center <small>(Beta)</small></div>
        <SelectableList selectedItemStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }} value={selectedChannel} onChange={this.handleChange} className={`${classes.list}${conversationsFetching ? ` ${classes.semitransparent}` : ''}`}>
          {channelsFormated.map(channel => (
          <ListItem
            className={classes.listItem}
            value={channel.channelId}
            key={channel.channelId}
            primaryText={channel.channelName}
            secondaryText={(channel.sentBy) ? (
              <div className={classes.secondaryText}>
                Sent {channel.sentAtFormatted} by {channel.sentBy.name || channel.sentBy.email} to {channel.recipients.length} {pluralize('Partner', channel.recipients.length)}
              </div>
            ) : undefined}
            secondaryTextLines={1}
          />
          ))}
        </SelectableList>
      </div>
    );
  }
}

massMessagingList.propTypes = {
  channels: PropTypes.array,
  classes: PropTypes.object,
  conversationsFetching: PropTypes.bool,
  handleConfirm: PropTypes.func,
  howMany: PropTypes.number,
  routerPush: PropTypes.func,
  selectChannel: PropTypes.func,
  selectedChannel: PropTypes.string,
};

massMessagingList.defaultProps = {
  handleConfirm: () => { console.log('confirmed'); },
  howMany: 0,
};

const select = (state) => ({
  channels: state.workspace.channels,
  selectedChannel: state.workspace.selectedChannel,
  conversationsFetching: state.workspace.conversationsFetching,
});

export default connect(select, {
  selectChannel,
  routerPush,
})(injectSheet(styles)(massMessagingList));



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/workspace/list.jsx